enum PrimaryCtaType {
  CancelPreOrder = 'CancelPreOrder',
  ContinuePurchase = 'ContinuePurchase',
  Default = 'Default',
  DisabledGetStarted = 'DisabledGetStarted',
  DisabledPreOrder = 'DisabledPreOrder',
  GetAlerts = 'GetAlerts',
  GetStarted = 'GetStarted',
  NotifyMe = 'NotifyMe',
  Reservable = 'Reservable',
  Reservation = 'Reservation',
  ViewSimilarVehicles = 'ViewSimilarVehicles'
}

export default PrimaryCtaType;
